<template>
  <div class="box text-center">
    <!-- /.box-header -->
    <div class="box-body" v-if="categoryList.length === 1 && !productList.length">
      無商品，請新增
    </div>
    <div class="box-body" v-else>
      <div class="col-xs-12 y-middle">
        <div class="inline-block pull-left">
          <h4 class="pull-left">
            商品
          </h4>
        </div>
        <div>
          <button class="btn btn-danger m-y-10 inline-block pull-right" data-toggle="modal" data-target="#delModal">
            刪除
          </button>
          <button
            class="btn btn-default btn-black m-y-10 inline-block m-r-10 pull-right"
            @click="gotoCrProducts"
          >
            新增
          </button>
          <button class="btn btn-default btn-black m-y-10 inline-block m-r-10 pull-right" data-toggle="modal" @click="show.easy = !show.easy">
            <span v-if="!show.easy">簡易</span>
            <span v-else>進階</span>
          </button>
          <button class="btn btn-primary m-y-10 pull-right m-r-10 " data-toggle="modal" @click="copyProduct">複製商品</button>
        </div>
      </div>
      <div class="col-xs-12">
        <div class="col-xs-12 col-md-2 text-left">
          <div>
            <select class="form-control" style="height: 46px" v-model="select.category">
              <option
                v-for="category in categoryList"
                :key="category.item_id"
                :value="category.item_id"
              >
                {{ category.name }}{{ category.remark ? ` (${category.remark})` : '' }}
              </option>
            </select>
          </div>
          <div class="bg-light-gray m-t-10 select-element-block">
            <div class="select-element" v-for="(product, index) in productList" :class="{'active': curId === product.item_id}" @click="clickProduct(product, index)" :disabled="isLoad || curId === product.item_id">
              <span class="text-w-600">{{product.name}}</span> <small style="opacity: .7;">&nbsp;&nbsp;{{product.remark}}</small>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-10">
          <ul class="col-xs-12 nav nav-tabs m-l-10 m-r-10">
            <li role="presentation" :class="{'active': tab == 1}" @click="tab = 1">
              <a>明細</a>
            </li>
            <li role="presentation" :class="{'active': tab == 2}" @click="tab = 2">
              <a>組合 <span class="text-danger" v-if="!combinationList.length"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></span></a>
            </li>
          </ul>
          <div class="box-body col-xs-12" v-if="!productList.length">
            <p class="text-center text-danger col-xs-12" style="margin: 50px 0px">此分類無任何商品</p>
          </div>
          <div class="box-body form menu-form col-xs-12" v-else>
            <div class="col-xs-12">
              <div class="col-xs-6 text-left">
                <div class="col-xs-12" v-if="tab === 2">
                  <button class="btn btn-default m-y-10 btn-combine" v-for="combine in combinationList" :class="{'active': curCId === combine.combine_id}" @click="clickCombine(combine.combine_id)">{{combine.name}}</button>
                </div>
              </div>
              <div class="col-xs-6 text-left">
                <div class="col-xs-12 text-right" v-if="tab === 2">
                  <button class="btn btn-primary m-y-10 m-r-10 " data-target="#choseProdModal" data-toggle="modal" v-if="curCId">複製組合</button>
                  <button class="btn btn-black m-y-10 m-r-10 " @click="newCombine()">新增組合</button>
                  <button class="btn btn-danger m-y-10 inline-block pull-right" data-toggle="modal" data-target="#delCombineModal">
                    刪除組合
                  </button>
                </div>
              </div>
            </div>
            <br>
            <div class="col-xs-12 col-md-6 p-r-5" v-show="tab === 1" >
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>產品名稱</span>
                <input class="form-control" placeholder="" type="text" v-model="productInfo.name">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>排<div class="inline-block w-35"></div>序</span>
                <input class="form-control" placeholder="" type="text" v-model="productInfo.sort" @keyup="veritySort()" maxlength="4" ref="sort">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>價<div class="inline-block w-35"></div>格</span>
                <input class="form-control" placeholder="" type="text" v-model="productInfo.price" @keyup="verityPrice()" maxlength="9" ref="price">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><div class="inline-block w-22"></div>備<div class="inline-block w-35"></div>註</span>
                <input class="form-control" placeholder="" type="text" v-model="productInfo.remark" maxlength="45">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>商品類型</span>
                <div class="form-group">
                  <select class="form-control h-34" v-model="productInfo.sub_type" >
                    <option :value="0">一般商品</option>
                    <option :value="101">塑膠袋</option>
                  </select>
                </div>
              </div>
              <br />
            </div>
            <div class="col-xs-12 col-md-6 p-l-5" v-show="!show.easy && tab === 1">
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>選購數量</span>
                <div>
                  <input style="width: calc(50% - 10px)" class="c-auto form-control" placeholder="0為無上限" type="text" @keyup="verityMinLimit()" v-model="productInfo.min_limit" maxlength="9" ref="minLimit">
                  <span class="pull-left" style="line-height: 38px; width: 20px">~</span>
                  <input style="width: calc(50% - 10px)"  class="c-auto form-control" placeholder="0為無上限" type="text" @keyup="verityMaxLimit()" v-model="productInfo.max_limit" maxlength="9" ref="maxLimit">
                </div>
              </div>
              <br>
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>價格類型</span>
                <div class="form-group">
                  <select class="form-control h-34" v-model="productInfo.price_type" >
                    <option :value="1">免稅價格</option>
                    <option :value="3">含稅價格</option>
                  </select>
                </div>
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><div class="inline-block w-22"></div>熱<div class="inline-block w-35"></div>量</span>
                <input class="form-control" placeholder="" type="text" v-model="productInfo.calorie" @keyup="verityCalorie()" ref="calorie">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><div class="inline-block w-22"></div>描<div class="inline-block w-35"></div>述</span>
                <input class="form-control" placeholder="" type="text" v-model="productInfo.description" maxlength="45">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon">商品料號</span>
                <input class="form-control" placeholder="" type="text" v-model="productInfo.vendor_custom_id" maxlength="30">
              </div>
              <br />
            </div>
            <div class="col-xs-12 col-md-6 p-r-5" v-show="tab === 2">
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>組合名稱</span>
                <input class="form-control" placeholder="" type="text" v-model="combineDetail.name">
                <!--<span class="input-group-addon no-border">組合</span>-->
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>常見價格</span>
                <div class="radio text-left h-38" style="border-left: 1px solid #d2d6de">
                  <label class="m-l-15">
                    <input type="radio" name="commonRadio" :value="1" v-model="combineDetail.is_common" style="top: 12px;">
                    <div style="top: 8px; left: 8px;">是</div>
                  </label>
                  <label class="m-l-15">
                    <input type="radio" name="commonRadio" :value="0" v-model="combineDetail.is_common" style="top: 12px;">
                    <div style="top: 8px; left: 8px;">否</div>
                  </label>
                </div>
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><div class="inline-block w-22"></div>備<div class="inline-block w-35"></div>註</span>
                <input class="form-control" placeholder="" type="text" v-model="combineDetail.remark" maxlength="45">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>配料群組</span>
                <button class="form-control btn btn-default" style="width: auto" data-toggle="modal" data-target="#choseModal">選擇配料群組</button>
              </div>
              <br>
            </div>
            <div class="col-xs-12 col-md-6 p-l-5"  v-show="!show.easy && tab === 2">
              <div class="input-group">
                <span class="input-group-addon"><div class="inline-block w-22"></div>商品價格</span>
                <input class="form-control" placeholder="選取組合內的選項皆為此價格" type="text" v-model="combineDetail.product.edge_price" @keyup="verityPriceProduct()" maxlength="9" ref="priceProduct">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><div class="inline-block w-22"></div>組合價格</span>
                <input class="form-control" placeholder="選取組合內的選項皆為此價格" type="text" v-model="combineDetail.price" @keyup="verityPriceCombine()" maxlength="9" ref="priceCombine">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><div class="inline-block w-22"></div>價格類型</span>
                <div class="form-group">
                  <select class="form-control h-34" v-model="combineDetail.price_type" >
                    <option :value="1">免稅價格</option>
                    <option :value="3">含稅價格</option>
                  </select>
                </div>
              </div>
              <br />
              <div class="input-group" v-show="checkAdjustActive">
                <span class="input-group-addon"><span class="text-red">＊ </span>配料單選</span>
                <button class="form-control btn btn-default" style="width: auto" data-toggle="modal" data-target="#choseOptionModal">選擇特定配料</button>
              </div>
              <br>
              <div class="input-group" v-show="checkAdjustActive">
                <span class="input-group-addon"><span class="text-red">＊ </span>組合內金額</span>
                <button class="form-control btn btn-default" style="width: auto" data-toggle="modal" data-target="#choseMoneyModal">變更配料金額</button>
              </div>
              <br>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box-footer text-center">
      <button class="btn btn-default" @click="gotoOut">
        返回
      </button>
      <button
        v-if="categoryList.length === 1 && !productList.length"
        class="btn btn-default btn-black"
        @click="gotoCrProducts"
      >
        新增
      </button>
      <button class="btn btn-success" @click="clickSave" v-else-if="productList.length">
        儲存
      </button>
    </div>
    <br />
    <c-modal :hideCancel="true" :elementList="allProductList" :option="choseProdOption" :curId="curId" @trigger="trigger"></c-modal>
    <c-modal :hideCancel="true" :elementList="adjustList" :option="choseOption" @trigger="trigger"></c-modal>
    <c-o-modal :hideCancel="true" :adjustList="adjustList" :option="optionOption" @trigger="trigger"></c-o-modal>
    <c-m-modal :hideCancel="true" :adjustList="adjustList" :option="moneyOption" @trigger="trigger"></c-m-modal>
    <m-modal class="text-left" :option="delProductOption" @trigger="trigger"></m-modal>
    <m-modal class="text-left" :option="delCombineOption" @trigger="trigger"></m-modal>
  </div>
</template>
<script>
import $ from 'jquery'
import AdjustModal from './AdjustModal.vue'
import OptionModal from './OptionModal.vue'
import { mapActions, mapGetters } from 'vuex'
import ChoseModal from '../../../elements/ChooseModal.vue'
import ChoseOptionModal from '../../../elements/ChooseOptionModal.vue'
import ChoseMoneyModal from '../../../elements/ChooseMoneyModal.vue'
import matcherModal from '../../../elements/Modal.vue'
import NdExtendHandleMenu from '@/extends/nd-extend-handle-menu.vue'

export default {
  name: 'CrProductTemp',
  extends: NdExtendHandleMenu,
  components: {
    'adjust-modal': AdjustModal,
    'option-modal': OptionModal,
    'c-modal': ChoseModal,
    'c-o-modal': ChoseOptionModal,
    'c-m-modal': ChoseMoneyModal,
    'm-modal': matcherModal
  },
  props: {
    'info': {
      type: Object
    }
  },
  data () {
    return {
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      menuId: this.$route.params.menu_id,
      brandId: this.$route.params.brand_id,
      show: {
        easy: true
      },
      tab: 1,
      current: {
        option: 0,
        adjust: 0,
        adjustId: 0,
        adjustName: '',
        adjustSubType: 0
      },
      brandName: '',
      brandType: '',
      adjustNumList: [],
      adjust: [],
      option: [],
      amount: {
        adjust: 1,
        option: 1
      },
      count: 20,
      maxTotal: 0,
      select: {
        category: 0
      },
      categoryList: [],
      adjustList: [],
      productList: [],
      allProductList: [],
      packageList: [
        {name: '比薩套餐', id: 1, active: false, remark: ''},
        {name: '你訂A餐', id: 2, active: false, remark: ''},
        {name: '你訂B餐', id: 3, active: false, remark: ''},
        {name: '牛丼套餐', id: 4, active: false, remark: ''},
        {name: '牛雞雙寶套餐', id: 5, active: false, remark: ''},
        {name: '帕尼尼A餐', id: 6, active: false, remark: ''}
      ],
      combineDetail: {
        name: '',
        is_common: '0',
        price: '',
        price_type: 3,
        description: '',
        remark: '',
        combine_id: '',
        product: { edge_price: '' }
      },
      productInfo: {
        name: '',
        sort: 1,
        description: '',
        remark: '',
        price: 0,
        price_type: 3,
        calorie: '',
        min_limit: 0,
        max_limit: 0,
        vendor_custom_id: ''
      },
      choseProdOption: {
        // 選取將被複製combine過去的product
        id: 'choseProdModal',
        title: '選擇商品',
        event: 'copyCombine'
      },
      choseOption: {
        // 配料群組modal資料
        id: 'choseModal',
        title: '選擇配料群組',
        event: 'chooseElement'
      },
      optionOption: {
        // 配料modal資料
        id: 'choseOptionModal',
        title: '單選配料',
        event: 'chooseOption'
      },
      moneyOption: {
        // 配料money modal資料
        id: 'choseMoneyModal',
        title: '單選配料',
        event: 'chooseMoney'
      },
      curId: 0,
      curCId: 0,
      oldInfo: {},
      cOldInfo: {},
      isLoad: false,
      defaultIndex: 1,
      delProductOption: {
        id: 'delModal',
        title: '刪除商品',
        body: '刪除時，若被上架中的菜單使用中，則會被阻擋<br>刪除商品時，會一併刪除商品的做法限制與定價規則',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'delProduct'
          }
        ]
      },
      delCombineOption: {
        id: 'delCombineModal',
        title: '刪除組合',
        body: '刪除時，若被上架中的菜單使用中，則會被阻擋',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'delCombine'
          }
        ]
      },
      combinationList: []
    }
  },
  methods: {
    ...mapActions(['setUpAdjust', 'setModal']),
    toggle () {
      $(this.$refs.infoAdjustModal).css('display')
    },
    maxAmount (max) {
      if (!max) return '無限制'
      else return max
    },
    getSubType (type) {
      if (type === 10) {
        return '大小'
      } else if (type === 20) {
        return '容器'
      } else if (type === 30) {
        return '甜度'
      } else if (type === 40) {
        return '溫度'
      } else {
        return '其他'
      }
    },
    getPriceType (type) {
      if (type === 1) return '免稅價格'
      else if (type === 3) return '含稅價格'
    },
    veritySort () {
      var e = $(this.$refs.sort)
      this.productInfo.sort = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    verityMinLimit () {
      var e = $(this.$refs.minLimit)
      this.productInfo.min_limit = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    verityMaxLimit () {
      var e = $(this.$refs.maxLimit)
      this.productInfo.max_limit = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    verityPrice () {
      var e = $(this.$refs.price)
      this.productInfo.price = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    verityPriceProduct () {
      var e = $(this.$refs.priceProduct)
      this.combineDetail.product.edge_price = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    verityPriceCombine () {
      var e = $(this.$refs.priceCombine)
      this.combineDetail.price = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    verityCalorie () {
      var e = $(this.$refs.calorie)
      this.productInfo.calorie = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    clickSave () {
      if (this.tab === 2) {
        this.checkCombineInput()
      } else this.checkInputEmpty()
    },
    checkCombineInput () {
      if (!this.allInput.cName) {
        this.$notify({
          title: '提醒',
          text: '請填寫組合名稱',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        this.upCombine()
        return true
      }
    },
    checkInputEmpty () {
      if (!this.allInput.name) {
        this.$notify({
          title: '提醒',
          text: '請填寫商品名稱',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (!this.allInput.sort) {
        this.$notify({
          title: '提醒',
          text: '請填寫排序',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (!parseInt(this.allInput.sort, 10)) {
        this.$notify({
          title: '請填寫正確排序',
          text: '排序範圍為1~9999',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (!this.allInput.min_limit) {
        this.$notify({
          title: '提醒',
          text: '請填寫最低購買數',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (!this.allInput.max_limit) {
        this.$notify({
          title: '提醒',
          text: '請填寫最高購買數',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        this.upProduct()
        return true
      }
    },
    upProduct (type) {
      const url = this.base + this.id + '/product/' + this.curId
      let data = {}
      const pInfo = this.productInfo
      const oldInfo = this.oldInfo
      if (type === 'sort') {
        data.sort = pInfo.sort
        data.price = pInfo.price
      } else {
        if (pInfo.sort !== oldInfo.sort) data.sort = pInfo.sort
        if (pInfo.name !== oldInfo.name) data.name = pInfo.name
        if (pInfo.vendor_custom_id !== oldInfo.vendor_custom_id) data.vendor_custom_id = pInfo.vendor_custom_id
        if (pInfo.description !== oldInfo.description) data.description = pInfo.description
        if (pInfo.remark !== oldInfo.remark) data.remark = pInfo.remark
        if (pInfo.price !== oldInfo.price) data.price = pInfo.price
        if (pInfo.price_type !== oldInfo.price_type) data.price_type = pInfo.price_type
        if (pInfo.calorie !== oldInfo.calorie) data.calorie = pInfo.calorie
        if (pInfo.min_limit !== oldInfo.min_limit) data.min_limit = pInfo.min_limit
        if (pInfo.max_limit !== oldInfo.max_limit) data.max_limit = pInfo.max_limit
        if (pInfo.sub_type !== oldInfo.sub_type) data.sub_type = pInfo.sub_type
      }
      if (JSON.stringify(data) !== '{}') {
        this.getDataH('put', url, data, (response) => {
          if (response.data.status === 200) {
            if (!type) {
              this.$notify({
                title: '提醒',
                text: '已更新' + pInfo.name,
                duration: 3000,
                type: 'success',
                width: 400
              })
            }
            if (pInfo.name !== oldInfo.name) {
              this.getMenuProduct('reload', pInfo.product_id)
            }
          }
        })
      }
    },
    upCombine () {
      let cDetail = this.combineDetail
      let oldInfo = this.cOldInfo
      let url = this.base + this.id + '/combination'
      let data = {}
      let aList = []
      let oList = []
      let adjust = this.adjustList.filter((o) => {
        return o.active
      })
      adjust.forEach((a) => {
        let aPrice = a.price
        let aLength = a.child_list.length
        let option = a.child_list.filter((op) => {
          return op.active
        })
        let oLength = option.length
        if (aLength === oLength) {
          let aItem = a.item_id + '/'
          let isOPrice = a.child_list.find((opt1) => {
            return opt1.price
          })
          if (aPrice) {
            aItem = aItem + parseInt(a.price, 10)
            aList.push(aItem)
          } else if (isOPrice) {
            a.child_list.forEach((opt) => {
              if (opt.active) {
                let oItem = opt.item_id + '/'
                let oPrice = opt.price
                if (oPrice) oItem = oItem + parseInt(oPrice, 10)
                oList.push(oItem)
              }
            })
          } else {
            aList.push(aItem)
          }
        } else {
          a.child_list.forEach((option) => {
            if (option.active) {
              let optItem = option.item_id + '/'
              let optPrice = option.price
              if (aPrice) optItem = optItem + parseInt(aPrice, 10)
              else if (optPrice) optItem = optItem + parseInt(optPrice, 10)
              oList.push(optItem)
            }
          })
        }
      })
      if (this.curCId) {
        url = url + '/' + cDetail.combine_id
        if (cDetail.name !== oldInfo.name) data.name = cDetail.name
        if (cDetail.price !== oldInfo.price) data.price = cDetail.price
        if (!cDetail.price) data.price = null
        if (cDetail.price_type !== oldInfo.price_type) data.price_type = cDetail.price_type
        if (cDetail.is_common !== oldInfo.is_common) data.is_common = cDetail.is_common
        data.product_id = this.curId + '/'
        if (cDetail.product.edge_price) data.product_id += cDetail.product.edge_price
        data.adjust = aList
        data.option = oList
      } else {
        data = {
          name: cDetail.name,
          price: cDetail.price,
          price_type: cDetail.price_type,
          is_common: cDetail.is_common,
          product_id: this.curId + '/',
          adjust: aList,
          option: oList
        }
        if (cDetail.product.edge_price) data.product_id += cDetail.product.edge_price
      }
      if (!data.price) data.price = null
      if (cDetail.remark !== oldInfo.remark) data.remark = cDetail.remark
      this.getDataH('put', url, data, (response) => {
        if (response.data.status === 200) {
          if (this.curCId) {
            this.$notify({
              title: '提醒',
              text: '已更新' + this.productInfo.name + '的' + data.name,
              duration: 3000,
              type: 'success',
              width: 400
            })
          } else {
            this.$notify({
              title: '提醒',
              text: '已新增' + data.name,
              duration: 3000,
              type: 'success',
              width: 400
            })
            this.getCombineList()
          }
        }
      })
    },
    delAdjust () {
      const url = this.base + this.id + '/adjust?adjust_id=' + this.adjustId
      this.getDataH('delete', url, null, (response) => {
        if (response.data.status === 200) {
          this.$notify({
            title: '提醒',
            text: '成功刪除調整類別',
            duration: 3000,
            type: 'success',
            width: 400
          })
          this.editState = false
          const id = this.modalId
          $('#' + id).modal('toggle')
          this.setUpAdjust(true)
        }
      })
    },
    clearData () {
      this.adjustInfo = {
        name: '',
        sort: 1,
        description: '',
        remark: '',
        price: '',
        price_type: 3,
        calorie: '',
        min_limit: '0',
        max_limit: '0',
        adjust_custom_id: '',
        is_mandatory: '0',
        is_common: '0',
        sub_type: '0'
      }
    },
    gotoCrProducts () {
      console.log('gotoCrProducts')
      let name = ''
      let params = {
        brand_id: this.$route.params.brand_id,
        store_id: ''
      }

      if (this.isStore && this.getRoleType !== 10) {
        name = 'StoreMenuProductCreate'
        params.store_id = this.$route.params.store_id
      } else {
        name = 'crProducts'
      }

      this.$router.push({ name, params })
    },
    gotoOut () {
      this.$router.go(-1)
    },
    trigger (event) {
      if (event === 'delProduct') {
        this.delProduct(this.productInfo.name)
      } else if (event === 'delCombine') {
        this.delCombine(this.combineDetail.name)
      } else if (event === 'copyCombine') {
        var copyList = []
        this.allProductList.forEach((prod) => {
          if (prod.active) {
            copyList.push(prod.item_id)
          }
        })
        this.copyCombine(copyList)
      }
    },
    copyCombine (list) {
      const url = this.base + this.id + '/combination/' + this.curCId + '/copy'
      const data = {
        product_list: list
      }
      this.getDataH('post', url, data, (response) => {
        if (response.data.status === 200) {
          this.$notify({
            title: '提醒',
            text: '已複製組合至其他商品',
            duration: 3000,
            type: 'success',
            width: 400
          })
          this.allProductList.forEach((prod) => {
            prod.active = false
          })
        }
      })
    },
    delProduct (delName) {
      const url = this.base + this.id + '/product?product_id=' + this.curId
      this.getDataH('delete', url, null, (response) => {
        if (response.data.status === 200) {
          this.$notify({
            title: '提醒',
            text: '已刪除' + delName,
            duration: 3000,
            type: 'success',
            width: 400
          })
          this.curId = ''
          this.curCId = ''
          this.getMenuProduct()
        }
      })
    },
    delCombine (delName) {
      const url = this.base + this.id + '/combination?combine_id=' + this.curCId
      this.getDataH('delete', url, null, (response) => {
        if (response.data.status === 200) {
          this.$notify({
            title: '提醒',
            text: '已刪除' + delName,
            duration: 3000,
            type: 'success',
            width: 400
          })
          this.curCId = ''
          this.getCombineList()
        }
      })
    },
    getMenuCategory () {
      const url = this.base + this.id + '/category/briefList'
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          var categoryList = response.data.list
          this.categoryList = categoryList
          var select = {
            name: '未分類',
            item_id: 0
          }
          this.categoryList.push(select)
          if (!this.select.category) this.select.category = categoryList[0].item_id
        }
      })
    },
    getAllMenuProduct () {
      this.allProductList = []
      const url = this.base + this.id + '/product/briefList?type=0'
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          const list = response.data.list
          list.forEach((category) => {
            category.child_list.forEach((prod) => {
              this.$set(prod, 'active', false)
              this.allProductList.push(prod)
            })
          })
        }
      })
    },
    copyProduct () {
      const url = this.base + this.id + '/product/' + this.curId + '/duplicate'
      this.getDataH('post', url, null, (response) => {
        if (response.data.status === 200) {
          this.$notify({
            title: '提醒',
            text: '成功複製商品到未分類',
            duration: 3000,
            type: 'success',
            width: 400
          })
          this.getMenuProduct('clickOther', response.data.new_product_id)
        }
      })
    },
    getMenuProduct () {
      this.curCId = 0
      this.combinationList = []
      let url = this.base + this.id + '/product/briefList'
      if (this.select.category) url = url + '?type=3&parent_item_id=' + this.select.category
      else url = url + '?type=2'
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          this.isLoad = false
          if (response.data.list.length) {
            this.productList = response.data.list[0].child_list
            if (this.productList.length) {
              if (!this.curId) this.curId = this.productList[0].item_id
              this.getProduct()
            }
          } else this.productList = []
        }
      })
    },
    clickProduct (product, index) {
      this.isLoad = true
      this.curId = product.item_id
      this.defaultIndex = index + 1
      this.productInfo = {}
      this.combineDetail = {
        name: '',
        is_common: 0,
        price: '',
        price_type: 3,
        description: '',
        remark: '',
        combine_id: '',
        product: { edge_price: '' }
      }
      this.adjustList = []
      this.getMenuProduct()
    },
    getProduct () {
      const url = this.base + this.id + '/product/' + this.curId
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          this.productInfo = response.data.product
          $.each(response.data.product, (index, value) => {
            this.$set(this.oldInfo, index, value)
          })
          if (!this.productInfo.sort || (!this.productInfo.price && parseInt(this.productInfo.price, 10) !== 0)) {
            this.productInfo.sort = this.defaultIndex
            this.productInfo.price = 1
            this.upProduct('sort')
          }
          this.getCombineList()
        }
      })
    },
    getCombineList () {
      const url = this.base + this.id + '/product/' + this.curId + '/combinationlist?page=1&size=20'
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          this.combinationList = response.data.combination_list
          if (!this.curCId && this.combinationList.length) {
            this.curCId = this.combinationList[0].combine_id
          }
          this.getMenuOption()
        }
      })
    },
    newCombine () {
      this.combineDetail = {
        name: '',
        is_common: 0,
        price: '',
        price_type: 3,
        description: '',
        remark: '',
        combine_id: '',
        product: { edge_price: '' }
      }
      this.curCId = 0
    },
    getMenuOption () {
      const url = this.base + this.id + '/option/briefList?type=1'
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          const adjustList = response.data.list
          adjustList.forEach((element) => {
            element.active = false
            element.price = ''
            element.child_list.forEach((option) => {
              option.active = false
              option.price = ''
            })
          })
          this.adjustList = adjustList
          this.clickCombine(this.curCId)
        }
      })
    },
    clickCombine (cId) {
      this.curCId = cId
      if (this.curCId) this.getCombine()
      else this.newCombine()
    },
    getCombine () {
      const url = this.base + this.id + '/combination/' + this.curCId
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          this.combineDetail = response.data.combination
          this.setCombine()
        }
      })
    },
    setCombine () {
      this.adjustList.forEach((clearA) => {
        clearA.active = false
        clearA.price = ''
        clearA.child_list.forEach((clearO) => {
          clearO.active = false
          clearO.price = ''
        })
      })
      this.combineDetail.adjust_list.forEach((cAdjust) => {
        this.adjustList.forEach((a) => {
          if (a.item_id === cAdjust.adjust_id) {
            a.active = true
            if (typeof cAdjust.edge_price !== 'undefined') a.price = cAdjust.edge_price
            a.child_list.forEach((o) => {
              o.active = true
            })
          }
        })
      })
      this.combineDetail.option_list.forEach((cOption) => {
        this.adjustList.forEach((adjust) => {
          adjust.child_list.forEach((option) => {
            if (option.item_id === cOption.option_id) {
              adjust.active = true
              option.active = true
              if (typeof cOption.edge_price !== 'undefined') option.price = cOption.edge_price
            }
          })
        })
      })
    }
  },
  mounted () {
    this.getMenuCategory()
    this.getAllMenuProduct()
  },
  computed: {
    ...mapGetters(['getUpAdjust', 'getModal', 'getRoleType']),
    checkAdjustActive () {
      var active = this.adjustList.find(function (o) {
        return o.active
      })
      return active
    },
    modalState () {
      if (this.state === 3 && !this.editState) return this.adjustInfo.name
      if (this.editState) return '編輯' + this.adjustInfo.name
      else return '新增調整類別'
    },
    allInput () {
      var info = this.productInfo
      return {
        name: this.checkInput(info.name),
        cName: this.checkInput(this.combineDetail.name),
        sort: this.checkInput(info.sort),
        vendor_custom_id: this.checkInput(info.vendor_custom_id),
        description: this.checkInput(info.description),
        remark: this.checkInput(info.remark),
        price: this.checkInput(info.price),
        calorie: this.checkInput(info.calorie),
        min_limit: this.checkInput(info.min_limit),
        max_limit: this.checkInput(info.max_limit)
      }
    },
    getDataH () {
      return this.$parent.getDataH
    },
    checkInput () {
      return this.$parent.checkInput
    },
    productNew () {
      var product = this.product
      return product
    },
    pageAmount () {
      return Math.ceil(this.maxTotal / this.count)
    }
  },
  watch: {
    getModal () {
      if (this.getModal) {
        this.$nextTick(function () {
          this.$set(this.adjustInfo, 'is_mandatory', '0')
          this.$set(this.adjustInfo, 'is_common', '0')
        })
        this.editState = false
        this.show.delNotify = false
        if (this.adjustId && this.state !== 1) {
          this.getAdjustInfo()
        }
      }
    },
    'select.category' () {
      this.curId = 0
      this.getMenuProduct()
    }
  }
}
</script>

<style lang="sass" scoped>
$light-gray: rgb(238, 238, 238)
$primary-color: #3c8dbc

.btn-black, .btn-black:hover, .btn-black:focus, .btn-black:active, .btn-black:active:focus
  border: 1px solid #333333
.m-r-10
  margin-right: 10px
.m-l-10
  margin-left: 10px
.p-r-5
  padding-right: 5px
.p-l-5
  padding-left: 5px
.box-body.menu-form
  left: 0
  width: auto
  padding: 0px 10px
.btn.disabled, .btn[disabled], fieldset[disabled] .btn
  cursor: auto
  opacity: 1
.bg-light-gray
  background: $light-gray
.select-element
  padding: 10px 15px
  cursor: pointer
  border-bottom: 2px solid #ddd
.select-element:last-child
  border-bottom: 0px
.select-element:hover, .select-element.active
  background: $primary-color
  color: #fff
.select-element-block
  margin-bottom: 10px
  max-height: calc(100vh - 360px)
  overflow: scroll
.option-chose
  background: $primary-color
  color: #ffffff
  padding: 6px 12px
.option-left-block
  width: calc(100% - 95px)
@media screen and (max-width: 767px)
  .select-element
    padding: 5px 15px
    font-size: 16px
  .select-element-block
    margin-left: 10px
    margin-right: 10px
    height: 30vh
  .option-left-block
    width: 100%
    padding-top: 45px
</style>



// WEBPACK FOOTER //
// CrProductTemp.vue?0fd51765